import React, { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { RevealLines } from "@/components/Reveal";

const AccountAuth = () => {
  const nav = useNavigate();
  const location = useLocation();
  const isRegister = location.pathname.endsWith("/register");
  const { login, register } = useAuth();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      if (isRegister) {
        await register(form.name, form.email, form.password);
        toast.success("Welcome to TAMASHii");
      } else {
        await login(form.email, form.password);
        toast.success("Welcome back");
      }
      nav("/account");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Something went wrong");
      setLoading(false);
    }
  };

  return (
    <div className="pt-[72px] min-h-screen">
      <div className="max-w-md mx-auto px-5 py-20">
        <p className="overline mb-4">{isRegister ? "Create Account" : "Welcome Back"}</p>
        <RevealLines tag="h1" immediate lines={isRegister ? ["Join the", "Atelier"] : ["Sign in"]} className="font-serif text-6xl md:text-7xl text-bone leading-[0.85] tracking-tight mb-12" />
        <form onSubmit={submit} className="space-y-5">
          {isRegister && (
            <div>
              <label className="overline block mb-2">Name</label>
              <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="account-name" required className="w-full bg-transparent border border-line px-4 py-3 text-bone focus:border-crimson outline-none font-mono text-sm" />
            </div>
          )}
          <div>
            <label className="overline block mb-2">Email</label>
            <input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="account-email" required className="w-full bg-transparent border border-line px-4 py-3 text-bone focus:border-crimson outline-none font-mono text-sm" />
          </div>
          <div>
            <label className="overline block mb-2">Password</label>
            <input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="account-password" required className="w-full bg-transparent border border-line px-4 py-3 text-bone focus:border-crimson outline-none font-mono text-sm" />
          </div>
          {error && <p className="text-crimson font-mono text-xs" data-testid="account-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="account-submit" className="btn-fill w-full py-4 flex items-center justify-center gap-3 overline text-sm disabled:opacity-50">
            {loading ? "Please wait…" : isRegister ? "Create Account" : "Sign In"} <ArrowRight size={16} />
          </button>
        </form>
        <p className="text-ash text-sm mt-8 font-mono">
          {isRegister ? "Already have an account? " : "New to TAMASHii? "}
          <Link to={isRegister ? "/account/login" : "/account/register"} className="text-bone link-underline" data-testid="account-toggle">
            {isRegister ? "Sign in" : "Create one"}
          </Link>
        </p>
      </div>
    </div>
  );
};

export default AccountAuth;
